module.exports = __webpack_public_path__ + "img/15.4a2a1881.png";